import { AddReportListType } from "./AddReport";
import { MdLock } from "react-icons/md";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { IoArrowForward } from "react-icons/io5";
import { RadioItem } from "./AddReportStyled";

export type AddListType = {
  title: string;
  subTitle: string;
  value: AddReportListType;
  disabled: boolean;
  icon: React.ReactNode;
};
type Props = {
  item: AddListType;
  index: number;
  onChangeType: (value: AddReportListType) => void;
  checkedType: AddReportListType;
  level: LEVEL_TYPE;
};

export default function AddReportItem(props: Props): JSX.Element {
  return (
    <RadioItem
      aria-disabled={props.item.disabled}
      isDisabled={props.item.disabled}
      checked={props.checkedType === props.item.value}
      level={props.level}
    >
      <input
        type="radio"
        name="addType"
        value={props.item.value}
        checked={props.checkedType === props.item.value}
        onChange={(e) => {
          props.onChangeType(props.item.value);
        }}
        readOnly={props.item.disabled}
        disabled={props.item.disabled}
        data-testid={`reports-add-type-radio-${props.item.value}`}
      />

      <span className="radio-item-checked-icon">{props.item.icon}</span>
      <div className="report-item-content">
        <div className="report-item-title">
          <div className="report-radio-item">{props.item.title}</div>
          {props.item.disabled && <MdLock opacity={0.5} size={16} />}
        </div>
        <div className="subtitle">{props.item.subTitle}</div>
        {props.level === LEVEL_TYPE.CP && (
          <div className="report-item-link">
            START {props.item.title} REPORT <IoArrowForward />
          </div>
        )}
      </div>
    </RadioItem>
  );
}
